import axios from "axios";

// for production
const firebase_function_url = "https://us-central1-bisleri-320a2.cloudfunctions.net/updateUserPassword";

// for staging
// const firebase_function_url = "https://updateuserpassword-4fq4idqroa-uc.a.run.app";


export const updatePassword = async (userId, newPassword) => {
  try {
    const response = await axios.post(firebase_function_url, {
      userId: userId,
      newPassword: newPassword,
    });
    console.log("Response:", response.data);
    return response.data; // Handling the response data as needed
  } catch (error) {
    console.error(
      "Error making POST request:",
      error.response ? error.response.data : error.message,
    );
    return null; // Handling error scenario
  }
};
